import React, { useEffect, useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionDetails } from '@mui/material';

import { StyledAccordion, StyledAccordionSummary } from './styles';
import { PetTitle } from 'components/PetTitle';

type CustomAccordionProps = {
  title?: string;
  expanded?: boolean;
};

const CustomAccordion: React.FC<CustomAccordionProps> = ({
  children,
  title,
  expanded = true,
}) => {
  const [isOpen, setIsOpen] = useState(expanded);

  useEffect(() => {
    setIsOpen(expanded);
  }, [expanded]);

  return (
    <StyledAccordion
      expanded={isOpen}
      onChange={() => {
        setIsOpen(!isOpen);
      }}
      sx={{ marginTop: 0, margin: 0 }}
    >
      <StyledAccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ minHeight: 24, padding: 0 }}
      >
        <PetTitle title={title ?? ''} marginBottom={0} marginRight={1} />
      </StyledAccordionSummary>

      <AccordionDetails sx={{ padding: 0, mt: 2 }}>{children}</AccordionDetails>
    </StyledAccordion>
  );
};

export default CustomAccordion;
